export default __webpack_public_path__ + "static/media/plus.23ddae94.svg";